/* eslint-disable @typescript-eslint/no-explicit-any */
import { UseLoggedContext } from '@mercadoni/sinister/dist/cjs/authentication/contexts'
import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client/contexts'
import { FC } from 'react'

interface FavoritesLogicProps {
  Wrapper: FC<any>
  className?: string
}

const FavoritesLogic: FC<FavoritesLogicProps> = ({ Wrapper, className }) => {
  const { lists } = UseClientModelContext()
  const { isLogged } = UseLoggedContext()

  if (!isLogged || !lists?.favorite?.display) {
    return null
  }

  return <Wrapper className={className} />
}

export default FavoritesLogic
